import React, { useEffect, useRef, useState } from "react";
import { useAPIs } from "../apis/APIsConfig";

import { useForm } from "../utils/hooks";
import InputMask from "react-input-mask";
import WithMainLayout from "../hocs/layouts/MainLayout";
import Accordion from "./common/Accordion";
import Select from "./common/Select";
import { getRelatives, saveInscription } from "../services/lastexpenses";

const LastExpenses = () => {
  useAPIs();

  const formInitialState = {
    nombre: "",
    apellido: "",
    cedula: "",
    email: "",
    telefonoMovil: "",
    telefonoResidencial: "",
    telefonoOficina: "",
    parentescoContactoA: "",
    nombreContactoA: "",
    apellidoContactoA: "",
    cedulaContactoA: "",
    emailContactoA: "",
    telefonoMovilContactoA: "",
    telefonoResidencialContactoA: "",
    telefonoOficinaContactoA: "",
    parentescoContactoB: "",
    nombreContactoB: "",
    apellidoContactoB: "",
    cedulaContactoB: "",
    emailContactoB: "",
    telefonoMovilContactoB: "",
    telefonoResidencialContactoB: "",
    telefonoOficinaContactoB: "",
    terminos: false,
  };
  const [success, setSuccess] = useState<boolean>(false);
  const [relatives, setRelatives] = useState<any[]>([]);
  const [formState, setError, changeHandler, resetAll, resetErrors, setInitialData] = useForm(formInitialState);

  useEffect(() => {
    getRelatives().then((res) => {
      if (res) {
        setRelatives(res.data.value);
      }
    });
  }, []);

  function disableButton() {
    return (
      !formState.data.terminos ||
      !formState.data.nombre ||
      !formState.data.apellido ||
      !formState.data.email ||
      formState.data.telefonoMovil.replaceAll("_", "").length !== 10 ||
      formState.data.cedula.replaceAll("_", "").length !== 11
    );
  }

  function submitForm() {
    saveInscription(formState.data).then((res: any) => {
      if (res && res.data) {
        resetErrors();
        if (res.data.fieldErrors) {
          res.data.fieldErrors.forEach((fieldError) => {
            setError(fieldError.field, fieldError.message);
          });
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        } else {
          setSuccess(true);
        }
      }
    });
  }

  function resetForm(){
    setInitialData(formInitialState);
    setSuccess(false);
  }

  return (
    <section className="content-last-expenses-enrollment">
      <div className="container">
        <div className="description">
          {!success && (
            <form
              id="formEnrollment"
              className="form-enrollment-request"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div
                className="items-form wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="0.4s"
              >
                <h2>Información del Afiliado</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 md:gap-y-10">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6 md:gap-y-10 col-span-1 md:col-span-2 lg:col-span-1">
                    <div className="form-group">
                      <label htmlFor="nombre">Nombres</label>
                      <br />
                      <span>
                        <input
                          type="text"
                          name="nombre"
                          className="form-control large"
                          placeholder="Juan"
                          required
                          value={formState.data.nombre}
                          onChange={changeHandler("nombre")}
                        />
                        {formState.errors.nombre && (
                          <p className="error">{formState.errors.nombre}</p>
                        )}
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="apellidos">Apellidos</label>
                      <br />
                      <span>
                        <input
                          type="text"
                          name="apellidos"
                          className="form-control large"
                          placeholder="Perez"
                          required
                          value={formState.data.apellido}
                          onChange={changeHandler("apellido")}
                        />
                        {formState.errors.apellido && (
                          <p className="error">{formState.errors.apellido}</p>
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6 md:gap-y-10 col-span-1 md:col-span-2 lg:col-span-1">
                    <div className="form-group">
                      <label htmlFor="cedula">Documento de Identidad</label>
                      <br />
                      <span>
                        <InputMask
                          type="text"
                          className="form-control large"
                          placeholder="000-0000000-0"
                          value={formState.data.cedula}
                          onChange={changeHandler("cedula", undefined, "-")}
                          mask="999-9999999-9"
                          maskPlaceholder={"_"}
                        />
                        {formState.errors.cedula && (
                          <p className="error">{formState.errors.cedula}</p>
                        )}
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone">Teléfono</label>
                      <br />
                      <span>
                        <InputMask
                          type="text"
                          className="form-control large"
                          placeholder="000-000-0000"
                          value={formState.data.telefonoMovil}
                          onChange={changeHandler(
                            "telefonoMovil",
                            undefined,
                            "-"
                          )}
                          mask="999-999-9999"
                          maskPlaceholder={"_"}
                        />
                        {formState.errors.telefonoMovil && (
                          <p className="error">
                            {formState.errors.telefonoMovil}
                          </p>
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Correo Electrónico</label>
                    <br />
                    <span>
                      <input
                        type="email"
                        name="email"
                        className="form-control large"
                        placeholder="ejemplo@gmail.com"
                        required
                        value={formState.data.email}
                        onChange={changeHandler("email")}
                      />
                      {formState.errors.email && (
                        <p className="error">{formState.errors.email}</p>
                      )}
                    </span>
                  </div>
                  {/*
                <div className="form-group">
                  <label htmlFor="city">Ciudad donde reside</label>
                  <br />
                  <span>
                    <input
                      type="text"
                      name="city"
                      className="form-control large"
                      placeholder="Santo Domingo"
                      required
                    />
                  </span>
                </div>
                */}
                </div>
              </div>
              {/******************************************
               **************  CONTACTO A  ****************
               ******************************************/}
              <div
                className="items-form wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="0.5s"
              >
                <h2>Persona de Contacto 1</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 md:gap-y-10">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-6 md:gap-y-10 col-span-1 md:col-span-2">
                    <div className="form-group">
                      <label>Nombres</label>
                      <br />
                      <span>
                        <input
                          type="text"
                          className="form-control large"
                          placeholder="Juan"
                          value={formState.data.nombreContactoA}
                          onChange={changeHandler("nombreContactoA")}
                        />
                      </span>
                    </div>
                    <div className="form-group">
                      <label>Apellidos</label>
                      <br />
                      <span>
                        <input
                          type="text"
                          className="form-control large"
                          placeholder="Perez"
                          value={formState.data.apellidoContactoA}
                          onChange={changeHandler("apellidoContactoA")}
                        />
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="email2">Correo Electrónico</label>
                      <br />
                      <span>
                        <input
                          type="email"
                          name="email2"
                          className="form-control large"
                          placeholder="ejemplo@gmail.com"
                          value={formState.data.emailContactoA}
                          onChange={changeHandler("emailContactoA")}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-6 md:gap-y-10 col-span-1 md:col-span-2">
                    <div className="form-group">
                      <label htmlFor="identity2">Documento de Identidad</label>
                      <br />
                      <span>
                        <InputMask
                          type="text"
                          className="form-control large"
                          placeholder="000-0000000-0"
                          value={formState.data.cedulaContactoA}
                          onChange={changeHandler(
                            "cedulaContactoA",
                            undefined,
                            "-"
                          )}
                          mask="999-9999999-9"
                          maskPlaceholder={"_"}
                        />
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone2">Teléfono</label>
                      <br />
                      <span>
                        <InputMask
                          type="text"
                          className="form-control large"
                          placeholder="000-000-0000"
                          value={formState.data.telefonoMovilContactoA}
                          onChange={changeHandler(
                            "telefonoMovilContactoA",
                            undefined,
                            "-"
                          )}
                          mask="999-999-9999"
                          maskPlaceholder={"_"}
                        />
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="residential">Teléfono Residencial</label>
                      <br />
                      <span>
                        <InputMask
                          type="text"
                          className="form-control large"
                          placeholder="000-000-0000"
                          value={formState.data.telefonoResidencialContactoA}
                          onChange={changeHandler(
                            "telefonoResidencialContactoA",
                            undefined,
                            "-"
                          )}
                          mask="999-999-9999"
                          maskPlaceholder={"_"}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>
                      Relación con el afiliado
                      <div className="form-icon">
                        <span
                          className="wpcf7-form-control-wrap"
                          data-name="your-subject"
                        >
                          <Select
                            options={relatives.map((r) => {
                              return {
                                value: r.codParentesco + "",
                                label: r.descripcion,
                              };
                            })}
                            selectedOption={formState.data.parentescoContactoA}
                            handelChange={(value) => {
                              changeHandler("parentescoContactoA", value)();
                            }}
                            placeholder="Seleccione tipo de relación"
                            label=" "
                          />
                        </span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {/******************************************
               **************  CONTACTO B  ****************
               ******************************************/}
              <div
                className="items-form wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="0.6s"
              >
                <h2>Persona de Contacto 2</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 md:gap-y-10">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-6 md:gap-y-10 col-span-1 md:col-span-2">
                    <div className="form-group">
                      <label>Nombres</label>
                      <br />
                      <span>
                        <input
                          type="text"
                          className="form-control large"
                          placeholder="Juan"
                          value={formState.data.nombreContactoB}
                          onChange={changeHandler("nombreContactoB")}
                        />
                      </span>
                    </div>
                    <div className="form-group">
                      <label>Apellidos</label>
                      <br />
                      <span>
                        <input
                          type="text"
                          className="form-control large"
                          placeholder="Perez"
                          value={formState.data.apellidoContactoB}
                          onChange={changeHandler("apellidoContactoB")}
                        />
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="email3">Correo Electrónico</label>
                      <br />
                      <span>
                        <input
                          type="email"
                          className="form-control large"
                          placeholder="ejemplo@gmail.com"
                          value={formState.data.emailContactoB}
                          onChange={changeHandler("emailContactoB")}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-6 md:gap-y-10 col-span-1 md:col-span-2">
                    <div className="form-group">
                      <label htmlFor="identity3">Documento de Identidad</label>
                      <br />
                      <span>
                        <InputMask
                          type="text"
                          className="form-control large"
                          placeholder="000-0000000-0"
                          value={formState.data.cedulaContactoB}
                          onChange={changeHandler(
                            "cedulaContactoB",
                            undefined,
                            "-"
                          )}
                          mask="999-9999999-9"
                          maskPlaceholder={"_"}
                        />
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="phone3">Teléfono</label>
                      <br />
                      <span>
                        <InputMask
                          type="text"
                          className="form-control large"
                          placeholder="000-000-0000"
                          value={formState.data.telefonoMovilContactoB}
                          onChange={changeHandler(
                            "telefonoMovilContactoB",
                            undefined,
                            "-"
                          )}
                          mask="999-999-9999"
                          maskPlaceholder={"_"}
                        />
                      </span>
                    </div>
                    <div className="form-group">
                      <label htmlFor="residential2">Teléfono Residencial</label>
                      <br />
                      <span>
                        <InputMask
                          type="text"
                          className="form-control large"
                          placeholder="000-000-0000"
                          value={formState.data.telefonoResidencialContactoB}
                          onChange={changeHandler(
                            "telefonoResidencialContactoB",
                            undefined,
                            "-"
                          )}
                          mask="999-999-9999"
                          maskPlaceholder={"_"}
                        />
                      </span>
                    </div>
                  </div>
                  <div className="form-group">
                    <label>
                      Relación con el afiliado
                      <div className="form-icon">
                        <span
                          className="wpcf7-form-control-wrap"
                          data-name="your-subject"
                        >
                          <Select
                            options={relatives.map((r) => {
                              return {
                                value: r.codParentesco + "",
                                label: r.descripcion,
                              };
                            })}
                            selectedOption={formState.data.parentescoContactoB}
                            handelChange={(value) => {
                              changeHandler("parentescoContactoB", value)();
                            }}
                            placeholder="Seleccione tipo de relación"
                            label=" "
                          />
                        </span>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <ul
                className="list-terms-and-procedure wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="0.7s"
              >
                <li>
                  <Accordion title="Términos y Condiciones">
                    <div className="description">
                      <p>
                        Es un programa de fidelización de clientes mediante el
                        cual AFP Crecer provee un beneficio en especie para
                        gastos funerarios en caso de fallecimiento del afiliado
                        que esté inscrito en el programa.
                      </p>
                      <div className="block">
                        <p>Los requisitos para acceder a este beneficio son:</p>
                        <ol>
                          <li>
                            Ser afiliado activo de AFP Crecer (cotizante o no
                            cotizante).
                          </li>
                          <li>Tener un correo electrónico.</li>
                          <li>
                            Completar el registro con los datos personales
                            requeridos.
                          </li>
                        </ol>
                      </div>
                      <p>
                        El registro en el programa tendrá una vigencia de un
                        año, renovable de forma indefinida mientras el programa
                        esté activo, el afiliado se encuentre con vida y
                        mantenga su afiliación en AFP Crecer.
                      </p>
                      <p>
                        El registro es gratuito para el afiliado. El beneficio
                        no es transferible a terceros.
                      </p>
                      <p>
                        Los afiliados nuevos por traspaso tendrán un periodo de
                        espera de seis (6) meses para su ingreso al programa.
                      </p>
                      <div className="block">
                        <p>
                          La cobertura máxima por evento (fallecimiento del
                          afiliado) es la siguiente:
                        </p>
                        <ol>
                          <li>
                            Cobertura en especie a través de la red de
                            prestadores de servicios funerarios seleccionados
                            por AFP Crecer hasta un monto máximo de
                            RD$50,000.00. La lista de funerarias disponibles
                            será publicada en nuestra página Web.
                          </li>
                        </ol>
                      </div>
                      <p>
                        El registro en el programa será mediante la plataforma o
                        mediante el Centro de Contacto de AFP Crecer. Para ello,
                        el afiliado deberá registrar sus Datos Personales
                        requeridos para su inscripción en el programa, así como
                        de un familiar o persona de contacto. Los Datos
                        Personales registrados tendrán el tratamiento de nuestra{" "}
                        <a href="https://afpcrecer.com.do/politica-de-privacidad/">
                          Política de Privacidad.
                        </a>{" "}
                        AFP Crecer se reserva el derecho de contactar a los
                        afiliados registrados, incluyendo a sus familiares a
                        fines de confirmar el registro, ofrecer orientación
                        sobre el programa e información general previsional, así
                        como el ofrecimiento de beneficios conexos al programa.
                      </p>
                      <p>
                        No existen exclusiones o restricciones de participación
                        por edad o condición preexistente.
                      </p>
                      <p>
                        AFP Crecer podrá suspender o cancelar este programa en
                        cualquier momento de su vigencia que lo considere
                        pertinente. Dicha suspensión o cancelación no genera
                        derechos de compensación en favor de los afiliados.
                      </p>
                      <p>
                        En caso de que AFP Crecer decida suspender o cancelar
                        este beneficio, garantizará la cobertura a todos los
                        afiliados inscritos hasta que se les complete su período
                        de vigencia, el cual culmina al cumplimiento del año de
                        inscripción.
                      </p>
                    </div>
                  </Accordion>
                </li>
                <li>
                  <Accordion title="Procedimiento de Reclamo">
                    <div className="description">
                      <p>
                        Cuando se presente el evento de fallecimiento, los
                        beneficiarios o familiares del afiliado deberán
                        contactar a una de las funerarias que estén dentro de la
                        red de prestadores seleccionada por AFP Crecer.
                      </p>
                      <p>
                        La funeraria prestará el servicio luego de confirmar que
                        el afiliado se encontraba hábil para recibir el
                        beneficio.
                      </p>
                      <p>
                        Los beneficiarios podrán solicitar a la funeraria
                        servicios o productos adicionales a los cubiertos en
                        este programa, debiendo en esos casos cubrir
                        directamente la diferencia entre el tope máximo a cubrir
                        por AFP Crecer (RD$50,000.00) y el monto total de los
                        servicios requeridos.
                      </p>
                      <p>
                        AFP Crecer no reembolsará o realizará un desembolso
                        económico en favor de los familiares o reclamantes del
                        beneficio por el fallecimiento ocurrido previo a la
                        inscripción al programa (incluyendo su renovación) o
                        cuando ya haya ocurrido el sepelio previo al reclamo del
                        beneficio.
                      </p>
                    </div>
                  </Accordion>
                </li>
              </ul>
              <div
                className="form-group wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="0.8s"
              >
                <div className="block">
                  <span
                    className="wpcf7-form-control-wrap"
                    data-name="your-donde"
                  >
                    <span className="wpcf7-form-control wpcf7-radio">
                      <span className="wpcf7-list-item first">
                        <label>
                          <input
                            onChange={changeHandler("terminos")}
                            type="checkbox"
                            value="aceptado"
                          />
                          <span className="wpcf7-list-item-label">
                            He leído y acepto los términos y condiciones del
                            programa.
                          </span>
                        </label>
                      </span>
                    </span>
                  </span>
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-large mt-8 md:mt-12 w-full md:w-auto wow fadeInUp"
                data-wow-duration="1.5s"
                data-wow-delay="0.9s"
                disabled={disableButton()}
                onClick={() => submitForm()}
              >
                Enviar Solicitud
              </button>
            </form>
          )}
          {success && (
            <div className="sent-message">
              <div className="contain-icon">
                <i className="icon icon-check"></i>
              </div>
              <div className="description">
                <h2>¡Registro Exitoso!</h2>
                <p>
                     El proceso de inscripción en últimos gastos se ha realizado correctamente.
                     En AFP Crecer eres importante. 
                </p>
                <button
                  onClick={() => resetForm()}
                  className="btn btn-primary btn-large px-6 md:px-11 mt-8 md:mt-12"
                >
                  <i className="icon icon-arrow-left mr-3 text-[12px]"></i>
                  Enviar otro mensaje
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default WithMainLayout(LastExpenses);
